"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ItemType;
(function (ItemType) {
    ItemType["PRODUCT"] = "PRODUCT";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
//# sourceMappingURL=Item.js.map